export const ONBOARDING_BEACONS_LOCAL_STORAGE_KEY = `OnboardingBeacons:localSettings`;
export const setOnboardingBeaconsSessionStorage = value => {
  try {
    sessionStorage.setItem(ONBOARDING_BEACONS_LOCAL_STORAGE_KEY, JSON.stringify(value));
  } catch (e) {
    // do nothing
  }
};
export const getOnboardingBeaconsSessionStorage = () => {
  try {
    var _sessionStorage$getIt;
    return JSON.parse((_sessionStorage$getIt = sessionStorage.getItem(ONBOARDING_BEACONS_LOCAL_STORAGE_KEY)) !== null && _sessionStorage$getIt !== void 0 ? _sessionStorage$getIt : 'false');
  } catch (e) {
    return false;
  }
};
export const cleanupOnboardingBeaconsSessionStorage = () => {
  try {
    sessionStorage.removeItem(ONBOARDING_BEACONS_LOCAL_STORAGE_KEY);
  } catch (e) {
    // do nothing
  }
};